import { Box, Link, Typography } from "@mui/material";

const HartSupportFooter = () => {
  return (
    <Box sx={{ mt: 4, mb: 0, textAlign: "center" }}>
      <Typography variant="body2" color="text.secondary">
        If you have issues logging into your account, please email{" "}
        <Link href="mailto:help@techallies.org">help@techallies.org</Link>.
      </Typography>
      <Typography variant="body2" color="text.secondary">
        For all other issues and questions, including data concerns, please email{" "}
        <Link href="mailto:it@hartresearch.com">it@hartresearch.com</Link>.
      </Typography>
    </Box>
  );
};

export default HartSupportFooter;
